import React from "react";
import { Loader2 } from "lucide-react";

const MODES = [["best", "Best match"], ["cheapest", "Cheapest"], ["house", "House brand"]];

export default function StorePicker({ shop, setShop, mode, setMode, matching }) {
  return (
    <div className="bg-white rounded-3xl border-2 border-[#FDECEF] p-3 shadow-soft" data-testid="store-picker">
      <div className="flex items-center gap-2">
        <p className="text-[11px] font-bold text-sorted-slate flex-1">Show products as they appear in</p>
        {matching && <span className="text-[11px] font-bold text-sorted-rose flex items-center gap-1" data-testid="store-matching"><Loader2 size={11} className="animate-spin" /> Millie's matching…</span>}
      </div>
      <div className="mt-1.5 bg-muted rounded-full p-1 flex">
        {[["woolies", "Woolworths"], ["coles", "Coles"]].map(([k, l]) => (
          <button key={k} onClick={() => setShop(k)} data-testid={`store-${k}`}
            className={`flex-1 py-2 rounded-full text-xs font-bold transition-colors ${shop === k ? "bg-sorted-ink text-white" : "text-sorted-slate"}`}>{l}</button>
        ))}
      </div>
      <div className="mt-2 flex gap-1.5">
        {MODES.map(([k, l]) => (
          <button key={k} onClick={() => setMode(k)} data-testid={`store-mode-${k}`}
            className={`flex-1 py-1.5 rounded-full text-[11px] font-bold border-2 transition-colors ${mode === k ? "bg-sorted-peach border-sorted-peach text-sorted-ink" : "bg-white border-[#FDECEF] text-sorted-slate"}`}>{l}</button>
        ))}
      </div>
    </div>
  );
}
